<template>
  <search-page
    :page-size="page ? page.size : undefined"
    :page-size-options="pageSizeOptions"
    :results-subheader="
      page && page.numberOfElements
        ? $t('common.resultsSubheader', {
            firstIndex: page.number * page.size + 1,
            lastIndex: page.number * page.size + page.numberOfElements,
            totalElements: page.totalElements
          })
        : undefined
    "
    @selectPageSize="selectPageSize($event)"
  >
    <template slot="results" v-if="page && page.content">
      <full-page-modal
        ref="editorModal"
        header-class="text-white"
        header-bg-variant="primary"
        title="Pre-assegnazione"
        @ok="modalOk"
        @hidden="modalHidden"
      >
        <!--<b-tabs class="p-0" nav-wrapper-class="d-none">-->
        <editor
          style="padding: 0 !important;"
          ref="editor"
          v-if="selected"
          v-model="selected"
          :is-new="true"
          :errors="selectedValidationErrors"
          @reset-errors="resetSelectedErrors"
        ></editor>

        <!--:disabled="!editing"
          :errors="validationErrors"
          @cancel="cancel"
          @edit="edit"
          @removed="removed"
          @saved="saved"
          @save-error="handleError"
          @load-online-data="loadOnlineData"
          @load-offline-data="loadOfflineData"-->

        <!--</b-tabs>-->
      </full-page-modal>

      <template v-for="r in page.content">
        <b-card
          :key="r.id"
          class="m-2 cursor-pointer hover"
          border-variant="primary"
          @click.prevent="selectProduct(r)"
        >
          <p>
            Prodotto: <strong>{{ r.product.name }}</strong>
          </p>
          <p>
            Importo richiesta:
            <strong>€ {{ $number2text(r.requestedAmount) }}</strong>
          </p>
          <p>
            Importo erogato:
            <strong>€ {{ $number2text(r.providedAmount) }}</strong>
          </p>
        </b-card>
      </template>
    </template>
  </search-page>
</template>
<script>
import pluralize from "pluralize";
import lowerFirst from "lodash/lowerFirst";
import SearchPageMixin from "vue-template/protected/mixins/SearchPageMixin";
import fileService from "@/modules/microcredit/file/protected/MicroCreditFileService";
import Editor from "@/modules/microcredit/file/protected/MicroCreditFileForm";
import service from "./MicroCreditProductService";

export default {
  mixins: [SearchPageMixin],

  components: {
    Editor
  },

  data() {
    return {
      sort: {
        sort: "name",
        order: "ASC"
      },
      selected: null,
      selectedValidationErrors: null
    };
  },

  methods: {
    getService() {
      return service;
    },

    breadcrumbs() {
      const routeName = this.$route.name;
      const loadPageName = routeName.replace("Evaluation", "Request");
      const searchPageName = pluralize(loadPageName);

      return [
        {
          icon: "home",
          text: "Home",
          to: "/protected"
        },
        {
          text: () => this.$t("menu." + lowerFirst(searchPageName)),
          to: { name: searchPageName }
        },
        this.page && this.page.content.length
          ? {
              text: this.page.content[0].title,
              to: { name: loadPageName, id: this.page.content[0].id }
            }
          : {
              text: "<Loading>"
            },
        {
          text: () => this.$t("common.assign")
        }
      ];
    },

    async find() {
      try {
        const requestId = this.$route.params.id;

        const { data } = await this.getService().evaluate({
          parameters: this.parameters,
          pageRequest: this.pageRequest,
          sort: this.sort,
          requestId
        });
        this.page = data;
      } catch (e) {
        console.error("Error", e);
        await this.handleError(e);
      }
      console.log("page", this.page);
      this.$emit("breadcrumbs", this.breadcrumbs());
      if (this.$refs.modal) {
        this.$refs.modal.hide();
      }
    },

    async selectProduct(r) {
      console.log("r", r);
      if (
        confirm(
          "Sei sicuro di voler creare una pratica con il prodotto selezionato?"
        )
      ) {
        this.selected = r;
        this.$refs.editorModal.show();
      }
    },

    modalHidden() {
      this.selected = null;
    },

    async modalOk(evt) {
      evt.preventDefault();
      try {
        const { data } = await fileService.save({
          instance: this.selected,
          isNew: true
        });
        console.log("Inserted", data);
        this.$router.push({
          name: "MicroCreditFile",
          params: {
            id: data.id
          }
        });
      } catch (e) {
        if (e.statusCode == 422) {
          console.log("Handle validation errors", e.data);
        } else {
          await this.handleError(e);
        }
      }
    },

    resetSelectedErrors() {
      this.selectedValidationErrors = null;
    }
  }
};
</script>
